import PropTypes from 'prop-types'

import Text from 'components/common/Text'
import TextButton from 'components/common/TextButton'
import Icon from 'components/Icon'
import theme from 'theme'
import Popover from 'components/common/Popover'

function Collapsible({
  children,
  isOpen,
  title,
  headerStyle,
  renderEllipsisMenu,
  collapseWithChevron,
  onClick,
  setIsOpen,
  ...rest
}) {
  const handleClick = () => {
    const newState = !isOpen
    setIsOpen(newState)
    if (onClick && newState) {
      onClick()
    }
  }

  return (
    <div data-test-collapsible>
      <div
        data-test-collapsible-header
        css={[
          {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: `${theme.space[1]}px ${theme.space[3]}px`,
            borderBottom: isOpen ? theme.border.base : ''
          },

          !collapseWithChevron && {
            cursor: 'pointer'
          },
          headerStyle
        ]}
        onClick={() => (collapseWithChevron ? undefined : handleClick())}
      >
        {typeof title !== 'string' ? (
          title
        ) : (
          <Text data-test-collapsible-title as="small">
            {title}
          </Text>
        )}
        <div
          css={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {renderEllipsisMenu && (
            <Popover
              openOnClick
              alignPopover={Popover.ALIGN_RIGHT}
              arrowSize={theme.space[4]}
              topBuffer={theme.space[7]}
              onClick={e => e.preventDefault()}
            >
              {({ getTargetProps, getPopoverProps }) =>
                renderEllipsisMenu({ getTargetProps, getPopoverProps })
              }
            </Popover>
          )}
          <TextButton
            css={{
              flex: 0,
              fontSize: theme.fontSizes[4],
              color: theme.colors.gray[2]
            }}
            onClick={() => (collapseWithChevron ? handleClick() : {})}
          >
            {isOpen ? (
              <Icon css={{ verticalAlign: 'middle' }} icon="chevronDown" />
            ) : (
              <Icon css={{ verticalAlign: 'middle' }} icon="chevronForward" />
            )}
          </TextButton>
        </div>
      </div>
      <div
        data-test-collapsible-content
        css={{
          width: '100%',
          display: isOpen ? 'block' : 'none',
          visibility: isOpen ? 'visible' : 'hidden'
        }}
        {...rest}
      >
        {children}
      </div>
    </div>
  )
}

Collapsible.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  title: PropTypes.node,
  renderEllipsisMenu: PropTypes.func,
  setIsOpen: PropTypes.func,
  headerStyle: PropTypes.object,
  collapseWithChevron: PropTypes.bool
}

Collapsible.defaultProps = {
  isOpen: false,
  headerStyle: {},
  title: '',
  collapseWithChevron: false,
  setIsOpen: () => {}
}

export default Collapsible
